import Divider from "components/Design/Divider/Divider";
import React from "react";
import cx from "classnames";
import ConditionalLink from "components/ConditionalLink";
import Icon from "components/CommonIcon/Icon";

export const MenuToolTipBodyItem = ({
  icon,
  children,
  selected,
  to,
  onClick,
}) => (
  <div className="flex items-center" onClick={onClick}>
    {icon}
    {to ? (
      <ConditionalLink link={to}>
        <span
          className={cx("inline-block font-semibold text-gray-text-2", {
            "ml-8": Boolean(icon),
          })}>
          {children}
        </span>
      </ConditionalLink>
    ) : (
      <span
        className={cx("inline-block font-semibold text-gray-text-2", {
          "ml-8": Boolean(icon),
        })}>
        {children}
      </span>
    )}
    {selected && (
      <span className="inline-flex ml-auto">
        <Icon name="tick" color="text-blue-ayana" fontSize="text-12" />
      </span>
    )}
  </div>
);

MenuToolTipBodyItem.defaultProps = {
  selected: false,
};

const MenuToolTipBody = ({ title, children }) => {
  return (
    <div className="font-mulish w-200 text-12-22 tracking-2 capitalize p-18">
      {title && (
        <div>
          <h3 className="font-bold">{title}</h3>
          <div className="py-10">
            <Divider transparent />
          </div>
        </div>
      )}
      <div className="space-y-8">{children}</div>
    </div>
  );
};

export default MenuToolTipBody;

export const DestinationToolTipBody = ({ children }) => {
  return (
    <div className="font-mulish w-350 text-12-22 tracking-2 capitalize p-12 pb-6">
      <div className="space-y-6">{children}</div>
    </div>
  );
};

export const BaliPropertyToolTipBody = ({ children }) => {
  return (
    <div className="font-mulish w-265 text-12-22 tracking-2 capitalize p-12">
      <div className="space-y-6">{children}</div>
    </div>
  );
};
